import { useState, useRef } from 'react';
import { Button } from './ui/button';
import { Label } from './ui/label';
import { Input } from './ui/input';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';
import { Upload, Link2, X, Image as ImageIcon } from 'lucide-react';
import { sendDocToS3 } from 'slices/thunk';
import { useDispatch } from 'react-redux';

interface ImageUploadProps {
  value: string;
  onChange: (imageUrl: string,ur:any) => void;
}

export function ImageUpload({ value, onChange }: ImageUploadProps) {
  const [previewUrl, setPreviewUrl] = useState<string>(value);
  const [urlInput, setUrlInput] = useState<string>(value);
  const fileInputRef = useRef<HTMLInputElement>(null);
 const dispatch :any= useDispatch()
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      // Validate file type
      if (!file.type.startsWith('image/')) {
        alert('Please select an image file');
        return;
      }

      // Validate file size (max 5MB)
      if (file.size > 5 * 1024 * 1024) {
        alert('File size should be less than 5MB');
        return;
      }
  
      // Create preview URL
      const reader = new FileReader();
      reader.onloadend = () => {
        const result = reader.result as string;
        setPreviewUrl(result);
        dispatch(sendDocToS3("coupan",file)).then((url:any)=>{
          onChange(result,url);

        })
      };
      reader.readAsDataURL(file);
    }
  };

  const handleUrlChange = (url: string) => {
    setUrlInput(url);
    setPreviewUrl(url);
    onChange(url,"");
  };

  const handleClearImage = () => {
    setPreviewUrl('');
    setUrlInput('');
    onChange('',"");
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const handleUploadClick = () => {
    fileInputRef.current?.click();
  };

  return (
    <div className="space-y-4">
      <div className="coupon-image-dropzone border-2 border-dashed rounded-lg p-6 transition-colors">
            <input
              ref={fileInputRef}
              type="file"
              accept="image/*"
              onChange={handleFileChange}
              className="hidden"
            />
            
            {!previewUrl ? (
              <div className="text-center">
                <ImageIcon className="mx-auto size-12 text-gray-400 mb-3" />
                <Button
                  type="button"
                  variant="outline"
                  className="coupon-image-button"
                  onClick={handleUploadClick}
                >
                  <Upload className="size-4 mr-2" />
                  Choose Image
                </Button>
                <p className="text-sm text-gray-500 mt-2">
                  PNG, JPG, GIF up to 5MB
                </p>
              </div>
            ) : (
              <div className="text-center">
                <div className="relative inline-block">
                  <img
                    src={previewUrl}
                    alt="Preview"
                    className="max-w-full h-48 rounded-lg object-cover border border-gray-200"
                    onError={(e) => {
                      e.currentTarget.src = '';
                      e.currentTarget.style.display = 'none';
                    }}
                  />
                  <Button
                    type="button"
                    variant="destructive"
                    size="sm"
                    className="absolute top-2 right-2"
                    onClick={handleClearImage}
                  >
                    <X className="size-4" />
                  </Button>
                </div>
                <div className="mt-3">
                  <Button
                    type="button"
                    variant="outline"
                    size="sm"
                    className="coupon-image-button"
                    onClick={handleUploadClick}
                  >
                    Change Image
                  </Button>
                </div>
              </div>
            )}
          </div>
    </div>
  );
}
